export const bolAwbLabels = {
  nonAms: 'NON_AMS',
  splitBill: 'SPLITBILL',
  itNumber: 'I.T. NUMBER',
  itDate: 'I.T. DATE',
  locationOfGoods: 'LOCATION OF GOODS/G.O.',
  centralizedExaminationSite: 'CES',
  boltype: 'BOL TYPE',
  bolnumber: 'BOL OR AWB #',
  container: 'CONTAINER #',
  size: 'SIZE'
}